/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description constants
 */

// todo check page roles
// todo remove color hex code and gradient from user roles

/**
 * user roles to check for
 */
const USER_ROLES = {
	internalAdmin: {
		title: 'Internal Admin',
		color: 'gold',
		hexCode: '#d48806',
		role: 'VT_INTERNAL_ADMIN',
		description:
			'Access to perform eligibility & claim status checks, payment requests, payers, locations, providers and add/deactivate users',
	},
	customerAdmin: {
		title: 'Admin',
		color: 'blue',
		hexCode: '#096dd9',
		role: 'VT_CUSTOMER_ADMIN',
		description:
			'Access to perform eligibility & claim status checks, payment requests, payers, locations, providers and add/deactivate users',
	},
	customerUser: {
		title: 'User',
		color: 'magenta',
		hexCode: '#c41d7f',
		role: 'VT_CUSTOMER_USER',
		description: 'Access to perform eligibility & claim status checks, payment requests, payers, locations, and providers',
	},
};

const {
	internalAdmin: { role: internalAdmin },
	customerAdmin: { role: customerAdmin },
	customerUser: { role: customerUser },
} = USER_ROLES;

/**
 * page roles for user access
 */
const PAGE_ROLES = {
	eligibility: {
		responses: [internalAdmin, customerAdmin, customerUser],
		newRequest: [internalAdmin, customerAdmin, customerUser],
		editRequest: [internalAdmin, customerAdmin, customerUser],
		viewResponse: [internalAdmin, customerAdmin, customerUser],
		// batch
		batch: {
			add: [internalAdmin, customerAdmin, customerUser],
			edit: [internalAdmin, customerAdmin, customerUser],
			viewResponse: [internalAdmin, customerAdmin, customerUser],
		},
	},
	claims: {
		responses: [internalAdmin, customerAdmin, customerUser],
		newRequest: [internalAdmin, customerAdmin, customerUser],
		viewResponse: [internalAdmin, customerAdmin, customerUser],
		editRequest: [internalAdmin, customerAdmin, customerUser],
		// worklist
		// TODO recheck with product team
		worklist: {
			listView: [internalAdmin, customerAdmin, customerUser],
			add: [internalAdmin, customerAdmin, customerUser],
			addManual: [internalAdmin, customerAdmin, customerUser],
			edit: [internalAdmin, customerAdmin, customerUser],
			viewResponse: [internalAdmin, customerAdmin, customerUser],
		},
	},
	// TODO
	payments: {
		submissions: [internalAdmin, customerAdmin, customerUser],
		quickPay: [internalAdmin, customerAdmin, customerUser],
		request: [internalAdmin, customerAdmin, customerUser],
	},

	help: {
		landing: [internalAdmin, customerAdmin, customerUser],
	},
	// TODO
	codeExplorer: {
		landing: [internalAdmin, customerAdmin, customerUser],
		allCodes: [internalAdmin, customerAdmin, customerUser],
		searchResults: [internalAdmin, customerAdmin, customerUser],
		codeDetails: [internalAdmin, customerAdmin, customerUser],
		favoriteCodes: [internalAdmin, customerAdmin, customerUser],
		codeList: [internalAdmin, customerAdmin, customerUser],
	},
	settings: {
		organization: {
			general: [internalAdmin, customerAdmin, customerUser],
			users: {
				listView: [internalAdmin, customerAdmin],
				add: [internalAdmin, customerAdmin],
				edit: [internalAdmin, customerAdmin],
			},
			subscriptions: [internalAdmin, customerAdmin],
			auditLogs: [internalAdmin, customerAdmin],
		},
		dataManagement: {
			providers: {
				listView: [internalAdmin, customerAdmin, customerUser],
				add: [internalAdmin, customerAdmin, customerUser],
				edit: [internalAdmin, customerAdmin, customerUser],
			},
			locations: {
				listView: [internalAdmin, customerAdmin, customerUser],
				add: [internalAdmin, customerAdmin, customerUser],
				edit: [internalAdmin, customerAdmin, customerUser],
			},
			payers: {
				listView: [internalAdmin, customerAdmin, customerUser],
				edit: [internalAdmin, customerAdmin, customerUser],
			},
		},
		integration: {
			payment: [internalAdmin, customerAdmin, customerUser],
			api: [internalAdmin, customerAdmin, customerUser],
		},
	},
};

/**
 * roles by priority , used in app actions
 */
const ROLES_BY_PRIORITY = [internalAdmin, customerAdmin, customerUser];

const FAQ_CATEGORIES = {
	Onboarding: {
		category: 'onboarding',
		title: 'Account Setup and Onboarding',
	},
	Provider: {
		category: 'provider',
		title: 'Provider Setup FAQs',
	},
	Payer: {
		category: 'payer',
		title: 'Payer Setup FAQs',
	},
	Eligibility: {
		category: 'eligibility',
		title: 'Eligibility Verification',
	},
	ClaimStatus: {
		category: 'claim',
		title: 'Claim Status Checks',
	},
	// TODO
	Payments: {
		category: 'payments',
		title: 'Payments',
	},
	// TODO
	CodeExplorer: {
		category: 'code-explorer',
		title: 'Code Explorer',
	},
	// Addon: {
	// 	category: 'addon',
	// 	title: 'Payments Add-on',
	// },
	Support: {
		category: 'support',
		title: 'Support',
	},
};

export { USER_ROLES, ROLES_BY_PRIORITY, PAGE_ROLES, FAQ_CATEGORIES };
